/** Layouts */
import BaseLayout from '@/views/rh/shared/objectif/layouts/BaseLayout';
import ShowLayout from '@/views/rh/shared/objectif/layouts/EntretienCollectifLayout';

/** Components */
import ObjectifShow from '@/views/rh/shared/objectif/objectif/pages/ObjectifShow';
import Document from '@/views/fichier/pages/Fichier';
import Note from '@/views/rh/shared/objectif/note/pages/Note';

export default [
  {
    path: '/rh/entretien/campagne/collectif/:entretienId/:sprov/:employeId/:prov',
    component: BaseLayout,
    children: [
      {
        path: 'show/:objectifId/',
        component: ShowLayout,
        children: [
          {
            path: '',
            component: ObjectifShow,
            name: 'rh_entretien_collectif_objectif-show',
            meta: {
              auth: true,
              module: 'rh',
              permission: 'access setting',
            },
          },
          {
            path: 'document/:documentUuid',
            component: Document,
            name: 'rh_entretien_collectif_objectif-document',
            meta: {
              auth: true,
              module: 'rh',
              permission: 'access setting',
            },
          },
          {
            path: 'note',
            component: Note,
            name: 'rh_entretien_collectif_objectif-note',
            meta: {
              auth: true,
              module: 'rh',
              permission: 'access setting',
            },
          },
        ],
      },
    ],
  },
];
